module.exports = __webpack_public_path__ + "img/icon_user.1842d686.svg";